module.exports = ".select-error {\n  color: darkred;\n}\n"